import { encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class DriverLogReportStore {
  loading = false;
  total = 0;
  driverLogData = [];
  tripData = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      driverLogData: observable,
      tripData: observable,

      loadData: action,
      loadDriverLogData: action,
      exportExcel: action,
      exportpdf: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    driverId,
    fromDate,
    toDate,
    offset,
    limit,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      driverId: driverId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport === 1) {
      var response = await postApi.getClient("report").post("/booking_report/driverLogReport", postData);
    } else {
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=traxi_booking&a=driverLogReport",
          "postData=" + base64Input
        );
    }
    this.driverLogData = response?.data?.data?.driverLogReport;

    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async loadDriverLogData({ driverId, fromDate, toDate, companyId }) {
    this.loading = true;
    var postData = {
      driverId: driverId,
      fromDate: fromDate,
      toDate: toDate,
      companyId: companyId,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport === 1) {
      var response = await postApi.getClient("report").post("/booking_report/driverLogDetails", postData);

      this.tripData = response?.data?.data?.driverLogDetails;

    } else {
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=traxi_booking&a=getDriversTripDetails",
          "postData=" + base64Input
        );
      this.tripData = response?.data?.data;

    }

    this.loading = false;
  }

  async exportExcel(getData) {
    if (config.pythonReport === 1) {
      try {
        await postApi.getClient("report").post("/booking_report/driverLogReport/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }

    } else {
      window.location.href =
        baseURL +
        "index.php?c=traxi_booking&a=exportDriverLogExcel&cid=" +
        getData.companyId +
        "&driverId=" +
        getData.driverId +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&userId=" +
        getData.userId +
        "&isadmin=" +
        getData.isadmin +
        "&colList=" +
        getData.colList;
    }
  }

  async exportpdf(getData) {
    if (config.pythonReport === 1) {
      try {
        await postApi.getClient("report").post("/booking_report/driverLogReport/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }

    } else {
      window.location.href =
        baseURL +
        "index.php?c=traxi_booking&a=exportDriverLogPdf&cid=" +
        getData.companyId +
        "&driverId=" +
        getData.driverId +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&userId=" +
        getData.userId +
        "&isadmin=" +
        getData.isadmin +
        "&colList=" +
        getData.colList;
    }
  }
}

export default DriverLogReportStore;
